<template>
    <v-product-line-layout :group="group" @remove="variationDeleted">
        <slot slot="title">{{group.ErpId}} - {{group.Name}}</slot>
        <slot slot="product">
            <v-marketing-delete @change="removeProductGroup" title="product.thumb.delete"></v-marketing-delete>
            <v-gallery :images="Images"></v-gallery>
            <div class="c-product-right u-font-small">
                <div>
                    <div class="c-product-info-parent">
                        <table class="c-product-info">
                            <tr>
                                <td><strong class="u-semi-bold">{{ $t('product.thumb.brand') }}:</strong></td>
                                <td>{{ group.Brand }}</td>
                            </tr>
                            <tr>
                                <td><strong class="u-semi-bold">{{ $t('product.thumb.category') }}:</strong></td>
                                <td>{{ group.BrandSubgroup }}</td>
                            </tr>
                            <tr>
                                <td><strong class="u-semi-bold">{{ $t('product.thumb.segment') }}:</strong></td>
                                <td>{{ group.Type }}</td>
                            </tr>
                        </table>

                        <table class="c-product-info">
                            <tr>
                                <td><label class="u-semi-bold">{{ $t('product.thumb.preOrder_discount') }}:</label></td>
                                <td>
                                    <v-input v-model.number="group.MaximumDiscount"
                                             @change="maxDiscountToChildren($event.target.value)"
                                             name="max_discount" type="number" :max=100 width="50px" :min=0 input-size="tiny">
                                    </v-input>
                                </td>
                            </tr>
                            <tr>
                                <td><label class="u-semi-bold">{{ $t('product.thumb.default_discount') }}:</label></td>
                                <td>
                                    <v-input v-model.number="group.DefaultDiscount"
                                             @change="defaultDiscountToChildren($event.target.value)"
                                             name="default_discount" type="number" :max="group.MaximumDiscount" width="50px" :min=0 input-size="tiny">
                                    </v-input>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </slot>
        <template v-if="group.Products.length > 0">
            <slot slot="variations" >
                <v-marketing-variation-line v-for="product in group.Products"
                                            :parent-id="parentId"
                                            :max-discount-value="maxDiscountValue"
                                            :default-discount-value="defaultDiscountValue"
                                            :product="product"
                                            :key="product.Id"
                                            :group-index="groupIndex">
                </v-marketing-variation-line>
            </slot>
        </template>
    </v-product-line-layout>
</template>

<script>
    import debounce from 'lodash/debounce'
    import VGallery from '@/components/gallery/Gallery'
    import VSelect from '@/components/form/Select'
    import VInput from '@/components/form/Input'
    import VMarketingVariationLine from '@/components/product/admin/MarketingVariationLine'
    import VSwitch from '@/components/form/Switch'
    import VMarketingDelete from '@/components/product/widgets/marketingDelete'
    import VProductLineLayout from '@/components/product/layout/ProductLineLayout'

    export default {
        props: {
            group: Object,
            parentId: String,
            groupIndex: Number
        },
        components: {
            VGallery,
            VSelect,
            VInput,
            VSwitch,
            VMarketingVariationLine,
            VMarketingDelete,
            VProductLineLayout,
        },
        data() {
            return {
                maxDiscountValue: null,
                defaultDiscountValue: null
            }
        },
        computed: {
            interactiveValues() {
                return {
                    DefaultDiscount: this.group.DefaultDiscount,
                    MaximumDiscount: this.group.MaximumDiscount
                }
            },
            Images() {
                let output = !this.group.Images.length ? null : [];

                this.group.Images.forEach((image, index) => {
                    if (index < 6) {
                        output.push({
                            src: image.replace('[WIDTH]', 230).replace('[HEIGHT]', 180),
                            selected: index === 0
                        })
                    }
                });
                return output
            }
        },
        methods: {
            updateMarketingGroup: debounce(function () {
                let params = this.interactiveValues;
                this.$store.dispatch('updateMarketingGroupToSheet', {
                    preOrderSheetId: this.parentId,
                    productGroupId: this.group.Id,
                    body: {
                        Id: this.group.Id,
                        ...params
                    }
                });
            }, 500),
            maxDiscountToChildren: debounce(function (value) {
                this.updateMarketingGroup();
                this.maxDiscountValue = parseInt(value);

                if(this.group.MaximumDiscount < this.group.DefaultDiscount)
                {
                    this.group.DefaultDiscount = this.group.MaximumDiscount;
                }
            }, 500),
            defaultDiscountToChildren: debounce(function (value) {
                this.updateMarketingGroup();
                this.defaultDiscountValue = parseInt(value);
            }, 500),
            removeProductGroup() {
                this.$store.dispatch('deleteMarketingGroupFromSheet', {
                    preOrderSheetId: this.parentId,
                    productGroupId: this.group.Id
                }).then(() => {
                    this.$emit('deleted');
                });
            },
            variationDeleted() {
                if(this.group.Products.length <= 1) {
                    this.$emit('deleted');
                }
            }
        }
    }
</script>

<style lang="scss" scoped>

    @import "~@/assets/scss/private";

</style>


// WEBPACK FOOTER //
// src/components/product/admin/MarketingLine.vue